import styled from 'styled-components'
import {
  DayGrid as OnboardingDayGrid,
} from '../OnboardingPension/OnboardingPension.styles'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  width: 100%;
`

export const Intro = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const IntroText = styled.p`
  margin: 0;
  font-size: 0.75rem;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.textMuted};
`

export const PensionForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  width: 100%;
`

export const Actions = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  max-width: 200px;
  margin-top: 0.25rem;

  @media (max-width: 768px) {
    max-width: 100%;
    margin-top: 0.5rem;
  }
`

export const SecondaryAction = styled.button`
  align-self: flex-start;
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  font-size: 0.8125rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.action.primary.bg};
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;

  &:hover:not(:disabled) {
    color: ${({ theme }) => theme.colors.textSecondary};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const DayGrid = styled(OnboardingDayGrid)`
  @media (min-width: 768px) {
    margin-left: 0;
    margin-right: auto;
  }
`
